import { render } from "./RegisterReferralGuide.vue?vue&type=template&id=573cf66d"
import script from "./RegisterReferralGuide.vue?vue&type=script&lang=js"
export * from "./RegisterReferralGuide.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__